import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";

// Pages
import HomePage from "./pages/HomePage";
import ServiceLandingPage from "./pages/ServiceLandingPage";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import Cookies from "./pages/Cookies";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AnalyticsLogin from "./pages/AnalyticsLogin";
import AnalyticsDashboardPage from "./pages/AnalyticsDashboard";
import Tracker from "./components/Tracker";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <Tracker />
          <Routes>
            {/* French — Home */}
            <Route path="/" element={<HomePage />} />

            {/* French — Service Landing Pages */}
            <Route path="/depannage-crevaison-domicile-cannes" element={<ServiceLandingPage />} />
            <Route path="/remplacement-pneus-express-alpes-maritimes" element={<ServiceLandingPage />} />
            <Route path="/extraction-ecrou-antivol-var" element={<ServiceLandingPage />} />
            <Route path="/depannage-cle-vehicule-perdue" element={<ServiceLandingPage />} />
            <Route path="/depannage-panne-batterie" element={<ServiceLandingPage />} />
            <Route path="/entretien-flottes-professionnelles" element={<ServiceLandingPage />} />

            {/* English — Home */}
            <Route path="/en" element={<HomePage />} />

            {/* English — Service Landing Pages */}
            <Route path="/en/flat-tire-repair-home-service-cannes" element={<ServiceLandingPage />} />
            <Route path="/en/express-tire-replacement-alpes-maritimes" element={<ServiceLandingPage />} />
            <Route path="/en/locking-wheel-nut-removal-var" element={<ServiceLandingPage />} />
            <Route path="/en/lost-car-key-roadside-assistance" element={<ServiceLandingPage />} />
            <Route path="/en/car-battery-jump-start-replacement" element={<ServiceLandingPage />} />
            <Route path="/en/professional-fleet-tyre-maintenance" element={<ServiceLandingPage />} />

            {/* Admin Pages (no translation) */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />

            {/* Analytics Pages (no translation) */}
            <Route path="/analytics" element={<AnalyticsLogin />} />
            <Route path="/analytics/dashboard" element={<AnalyticsDashboardPage />} />

            {/* Legal Pages — French only */}
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/cookies" element={<Cookies />} />

            {/* Catch-all slug for service pages */}
            <Route path="/en/:slug" element={<ServiceLandingPage />} />
            <Route path="/:slug" element={<ServiceLandingPage />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
